import { useCallback, useState } from "react";
import { GetPermissionByRoleId } from "../../../services/roleService";
import { useMount } from "../../../hooks/useMount";

const GetPermission = ({ roleId }) => {
    const [permission, setPermission] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchpermission = useCallback(async () => {
  if (!roleId) return;
  setLoading(true);
  try {
    const response = await GetPermissionByRoleId(roleId);
    if (response?.statusCode === 200 && response?.success) {
      setPermission(response.data);
    }
  } catch (err) {
    console.log(err);
  } finally {
    setLoading(false);
  }
}, [roleId]);

  useMount(fetchpermission);
    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">Permission List</h4>
                </div>

                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    )  : (
                        <>
                            {/* Total Records */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="mb-0">
                                    Total Records:
                                    <span className="badge bg-primary ms-2">
                                        {permission.length}
                                    </span>
                                </h4>
                               
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {permission.length > 0 ? (
                                            permission.map((p, index) => (
                                                <tr key={p.permissionId}>
                                                    <td>{index + 1}</td>
                                                    <td>{p.permissionName}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    className="text-center"
                                                >
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
export default GetPermission;
